// ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ° Â«ÑÐ°ÐºÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¶Ðµ ÐµÑÑÑÂ» Ð¿ÑÐ¸ Ð²Ð²Ð¾Ð´Ðµ VIN Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ.
// ÐÑÐ°Ð²Ð¸Ð»Ð° ÑÐ°Ð·Ð±Ð¾ÑÐ° ÑÑÑÐ¾ÐºÐ¸ ÑÐµ Ð¶Ðµ, ÑÑÐ¾ Ð½Ð° Ð±ÑÐºÐµ (CarsController.NormalizeVinQuery).

export const MIN_VIN_SEARCH_LENGTH = 5;
export const FULL_VIN_LENGTH = 17;

export const vinSearchQuery = (value) => {
  const normalized = String(value || '')
    .replace(/[^0-9a-z]/gi, '')
    .toUpperCase();
  return normalized.length < MIN_VIN_SEARCH_LENGTH ? null : normalized;
};

// Â«ÐÐ°ÑÐºÐ° ÐÐ¾Ð´ÐµÐ»Ñ, 2021, Ð±ÐµÐ»ÑÐ¹Â» â ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾, ÑÑÐ¾ Ð¸Ð·Ð²ÐµÑÑÐ½Ð¾.
export const carSummary = (car) =>
  [[car?.mark, car?.model].filter(Boolean).join(' '), car?.issueYear, car?.color].filter(Boolean).join(', ');

// ÐÐ¾Ð»Ð½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÐµÐ¼: Ð²Ð²ÐµÐ»Ð¸ Ð²ÐµÑÑ VIN, Ð° ÑÐ°ÐºÐ°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¶Ðµ Ð·Ð°Ð²ÐµÐ´ÐµÐ½Ð°.
export const isSameVin = (car, value) =>
  String(value || '').trim().length === FULL_VIN_LENGTH &&
  String(car?.vin || '').toUpperCase() === String(value).trim().toUpperCase();
